const RouteNames = {
  MainView: "MainView",
  MyPageDashboardView: "MyPageDashboardView",
  MyOrderHistoryView: "MyOrderHistoryView",
  MyCancellationView: "MyCancellationView",
  MenCategoriesView: "MenCategoriesView",
  WomenCategoriesView: "WomenCategoriesView",
  ProductWishList: "ProductWishList",
  BrandWishList: "BrandWishList",
  RestockNotificationView: "RestockNotificationView",
  BrandPromotionView: "BrandPromotionView",
  BestPromotionView: "BestPromotionView",
  EventPromotionView: "EventPromotionView",
  GolfTvPromotionView: "GolfTvPromotionView",
  MyGiftBoxView: "MyGiftBoxView",
  NoticeListView: "NoticeListView",
  NoticeDetailsView: "NoticeDetailsView",
  AllianceAndQnaView: "AllianceAndQnaView",
  FaqListView: "FaqListView",
  FaqDetailsView: "FaqDetailsView",
  ExhibitionPromotionView: "ExhibitionPromotionView",
  HotTagExhibitionPromotionView: "HotTagExhibitionPromotionView",
  ExhibitionDetailsView: "ExhibitionDetailsView",
  EventDetailsView: "EventDetailsView",
  BrandProductListView: "BrandProductListView",
  SearchResultView: "SearchResultView",
  MenProductListView: "MenProductListView",
  WomenProductListView: "WomenProductListView",
  GolfProductListView: "GolfProductListView",
  LivingProductListView: "LivingProductListView",
  GolfTvCannelProductsView: "GolfTvCannelProductsView",
  ProductDetailsView: "ProductDetailsView",
  CartView: "CartView",
  OrderToPresentView: "OrderToPresentView",
  OrderToBuyNowView: "OrderToBuyNowView",
  OrderInCartView: "OrderInCartView",
  OrderCompleteView: "OrderCompleteView",
  ServicePolicyView: "ServicePolicyView",
  MyNotificationView: "MyNotificationView",
  ReviewListView: "ReviewListView",
  ReviewHistoryView: "ReviewHistoryView",
  QnaListView: "QnaListView",
  MyShippingAddressView: "MyShippingAddressView",
  MyShippingAddressWriteForm: "MyShippingAddressWriteForm",
  MyRecommendUserView: "MyRecommendUserView",
  MyOrderDetailView: "MyOrderDetailView",
  AttendanceEvent: "AttendanceEvent",
  NotFound: "NotFound",
};

Object.freeze(RouteNames);

export default RouteNames;
